import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import axios from 'axios';
import { useDevice } from 'components/DeviceContext.js';

const Contato = () => {
	const { isMobile } = useDevice();
	const [formData, setFormData] = useState({
		nome: '',
		email: '',
		mensagem: '',
		telefone: '',
		cargo: '',
		entidade: '',
		municipio: '',
		sigla_uf: '',
		email_destino: 'a.social@cnm.org.br',
		origem: 'Observatorio das Drogas'
	});

	const [estados, setEstados] = useState([]);
	const [municipios, setMunicipios] = useState([]);
	const [enviado, setEnviado] = useState(false);

	useEffect(() => {
		// Buscar estados
		axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
			.then(response => {
				setEstados(response.data);
			})
			.catch(error => {
				console.error('Erro ao buscar estados:', error);
			});
	}, []);

	const handleEstadoChange = (e) => {
		const sigla_uf = e.target.value;
		setFormData({ ...formData, sigla_uf });
		// Buscar municípios do estado selecionado
		axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${sigla_uf}/municipios`)
			.then(response => {
				setMunicipios(response.data);
			})
			.catch(error => {
				console.error('Erro ao buscar municípios:', error);
			});
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		axios.post('https://contatos.cnm.org.br/api/faleconosco', formData)
			.then(response => {
				setEnviado(true);
				console.log('E-mail enviado com sucesso!');
				setFormData({
					nome: '',
					email: '',
					mensagem: '',
					telefone: '',
					cargo: '',
					entidade: '',
					municipio: '',
					sigla_uf: '',
					email_destino: 'andiara.silva@cnm.org.br',
					origem: 'Observatorio das Drogas'
				});
			})
			.catch(error => {
				console.error('Erro ao enviar dados:', error);
			});
		window.scrollTo(0, 0);
	};

	return (
		<Grid container
			style={{
				display: 'flex',
				justifyContent: 'center',
				flexDirection: isMobile ? 'column' : 'row',
				minHeight: '40%',
				fontFamily: 'Open Sans, sans-serif',
				margin: isMobile ? '0 0 5em' : '1em 0 10em',
				padding: isMobile ? '1em' : '0'
			}}>
			<Grid item xs={12} md={8} lg={6}>
				{enviado ? (
					<Typography style={{
						textAlign: 'center', fontSize: '1.5em', paddingTop: '2em'
					}}>Mensagem enviada com sucesso!</Typography>
				) : (

					<form onSubmit={handleSubmit} style={{
						// border: '2px solid var(--cinza)', borderRadius: '8px', padding: isMobile ? '1em' : '2em'
					}}>
						<Grid style={{ textAlign: 'center', paddingBottom: '1em' }}>
							<Typography style={{ textAlign: 'center', paddingTop: '1em', fontSize: '2em', fontWeight: '600' }}>Contato</Typography>
							<Typography variant="body1">Perguntas, sugestões e reclamações</Typography>
							<Typography variant="body1">Envie um e-mail e entraremos em contato</Typography>
						</Grid>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<FormControl fullWidth>
									<InputLabel id="uf-label">UF*</InputLabel>
									<Select
										labelId="uf-label"
										id="uf"
										name="sigla_uf"
										value={formData.sigla_uf}
										onChange={handleEstadoChange}
										required
									>
										<MenuItem value="">Escolha o Estado</MenuItem>
										{estados.map(estado => (
											<MenuItem key={estado.sigla} value={estado.sigla}>{estado.nome}</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControl fullWidth>
									<InputLabel id="municipio-label">Município*</InputLabel>
									<Select
										labelId="municipio-label"
										id="municipio"
										name="municipio"
										value={formData.municipio}
										onChange={handleChange}
										required
									>
										<MenuItem value="">Selecione um estado</MenuItem>
										{municipios.map(municipio => (
											<MenuItem key={municipio.id} value={municipio.nome}>{municipio.nome}</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="nome"
									name="nome"
									label="Nome"
									value={formData.nome}
									onChange={handleChange}
									placeholder="Seu nome"
									required
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="entidade"
									name="entidade"
									label="Órgão ou Empresa"
									value={formData.entidade}
									onChange={handleChange}
									placeholder="Informe o nome do órgão ou empresa"
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="cargo"
									name="cargo"
									label="Cargo"
									value={formData.cargo}
									onChange={handleChange}
									placeholder="Informe seu cargo"
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="email"
									name="email"
									type="email"
									label="E-mail"
									value={formData.email}
									onChange={handleChange}
									placeholder="Informe seu e-mail"
									required
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="telefone"
									name="telefone"
									label="Telefone"
									value={formData.telefone}
									onChange={handleChange}
									placeholder="(00) 00000-0000"
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									fullWidth
									id="mensagem"
									name="mensagem"
									label="Mensagem"
									value={formData.mensagem}
									onChange={handleChange}
									placeholder="Digite sua mensagem"
									multiline
									minRows={4}
									required
								/>
							</Grid>
							<Grid item xs={12}>
								<Button type="submit" variant="contained" color="primary" fullWidth>ENVIAR</Button>
							</Grid>
							<Grid
								container
								justifyContent="center"
								sx={{
									mt: 5,
									mb: 3,
								}}
							>
								<Grid
									item
									xs={12}
									md={8}
									sx={{
										textAlign: "center",
										backgroundColor: "#f5f7fa",
										padding: 3,
										borderRadius: 2,
										boxShadow: 2,
									}}
								>
									<Typography
										variant="h6"
										sx={{
											fontWeight: 600,
											mb: 1,
											color: "#0d47a1",
										}}
									>
										📩 Contato direto
									</Typography>

									<Typography variant="body1" sx={{ fontSize: "1.05rem" }}>
										<strong>Email:</strong> a.social@cnm.org.br
									</Typography>

									<Typography variant="body1" sx={{ fontSize: "1.05rem", mt: 1 }}>
										<strong>Telefone:</strong> (61) 2101-6689
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</form>
				)}
			</Grid>
		</Grid>
	);
};

export default Contato;
